import React, { useEffect, useState } from 'react';
import './Footer.css';
import logoImage from './images/logo/logo-last.svg'; // Import the logo image
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-logo">
            <a href="#home" onClick={() => scrollToSection('home')} className="logo-link">
              <img 
                src={logoImage} 
                alt="Kellink Tattoo" 
                className={`footer-logo-image ${isVisible ? 'visible' : ''}`} 
              />
            </a>
            <p className={`tagline ${isVisible ? 'visible' : ''}`}>{t('footer.companyName')}</p>
          </div>
          
          <div className="footer-nav">
            <h4>{t('footer.navigation')}</h4>
            <ul>
              <li><a href="#about" onClick={() => scrollToSection('about')}>{t('header.about')}</a></li>
              <li><a href="#artist" onClick={() => scrollToSection('artist')}>{t('header.artist')}</a></li>
              <li><a href="#services" onClick={() => scrollToSection('services')}>{t('header.services')}</a></li>
              <li><a href="#contact" onClick={() => scrollToSection('contact')}>{t('header.contact')}</a></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4>{t('footer.contact')}</h4>
            <ul>
              <li><a href="mailto:conlitchenko_gabriel@yahoo.com">conlitchenko_gabriel@yahoo.com</a></li>
              <li><a href="tel:+40743463712">0743 463 712</a></li>
              <li><a href="https://www.google.com/maps/place/Bacau,+Romania" target="_blank" rel="noopener noreferrer">Romania, Bacau</a></li>
            </ul>
          </div>
          
          <div className="footer-social">
            <h4>{t('footer.followUs')}</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1DYWFGYEgg/?mibextid=wwXIfr" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/kellink_tattoo/profilecard/?igsh=MThoeTcxZzdldGV4cA==" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.tiktok.com/@kellinktattoo.bacau?_t=ZN-8v3cYJC94Yo&_r=1" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} Kellink Tattoo. {t('footer.copyright')}</p>
          </div>
          <div className="footer-links">
            <a href="/privacy">{t('footer.links.privacy')}</a>
            <a href="/terms">{t('footer.links.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 